import classNames from 'classnames'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useMedia } from 'react-use'
import { mobileMedia, tabletMedia } from '../../../../config/mediaQuery'
import {
  getTranTypeIcon,
  selectSelector,
  setCurrentTransport,
} from '../../../../redux/slices/select'
import { fetchTranRoutes, fetchTranTypes } from '../../../../redux/thunks/select'
import CurrentItemTitle from './CurrentItemTitle'
import TransportItem from './TransportItem'

const TransportSwitcher = ({ noTitles = false }) => {
  const { currentTransport, tranTypes } = useSelector(selectSelector)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchTranTypes())
      .unwrap()
      .then((originalPromiseResult) => {
        dispatch(fetchTranRoutes())
      })
      .catch((rejectedValueOrSerializedError) => {})
  }, [dispatch])

  const handleTransport = (currentTransport) => {
    // console.log(currentTransport)
    dispatch(setCurrentTransport(currentTransport))
    dispatch(fetchTranRoutes())
  }

  const isMobile = useMedia(mobileMedia)
  const isTablet = useMedia(tabletMedia)

  const showCurrentItemTitle = isTablet || noTitles

  return (
    <div
      className={classNames('transport_switcher', {
        mobile: isMobile,
        tablet: isTablet,
        noTitles,
      })}
    >
      {showCurrentItemTitle && <CurrentItemTitle />}
      <div className="transport_items">
        {tranTypes.map((tranType) => {
          const { id, tranTitle, is_active } = tranType
          return (
            <TransportItem
              key={id}
              title={tranTitle}
              handler={() => handleTransport(tranType)}
              Icon={getTranTypeIcon(id)}
              active={currentTransport?.id === id}
              disabled={!is_active}
            />
          )
        })}
      </div>
    </div>
  )
}

export default TransportSwitcher
